/* Settle Supply Co. - demand-test v6 "checkout sold-out" (draft: Settle v6 CHECKOUT-SOLDOUT DRAFT).
   No payment is ever taken (payments are OFF on the store).

   PDP  : #ss-btn is a real Dawn <product-form> submit. Dawn's product-form.js POSTs /cart/add
          for the selected variant and opens the theme's native cart popup (cart-notification).
          This file only keeps the variant pills, button label, hidden variant id and theme price
          in step, and publishes ONE custom event per successful add:
            demand_test_add_to_cart {variant_id, product_id, value, price, quantity, currency, ...}
          (Shopify's native product_added_to_cart also fires from the /cart/add call; forward
          only ONE of the two to Meta as AddToCart - see APPLY-6.md.)
   Popup: the cart popup's "Check out" button ([data-ss-to-cart]) just goes to /cart: no sold-out
          reveal and no ss_checkout_click there.
   Cart : The /cart Checkout button, dynamic/express checkout buttons and
          theme links to /checkout are intercepted. On tap nothing navigates; the button turns to
          "Sold out", the sold-out copy + inline email form (form_type=customer, tags
          waitlist,<cart handles>[,<variant slug>]) appear, and
            ss_checkout_click {value, currency, item_count, items[], content_ids[], source}
          is published at most ONCE per session per cart (sessionStorage key = cart token + hash of the
          line items), so repeat taps and /cart refreshes do not re-count; a changed cart may fire again
          (forward to Meta as InitiateCheckout). Cart contents are kept.
          The Liquid is the hard block: every checkout button is type="button" with no name="checkout"
          (data-ss-checkout), the cart forms only post to /cart, and express checkout buttons are not
          rendered. If this file fails or loads late, a tap does nothing; it never reaches /checkout.
   Lead : after the email form posts (?customer_posted=true) -> demand_test_lead once per session.
   Every publish is mirrored as a DOM event "ss:analytics" and console.info("[ss]") for QA. */
(function () {
  'use strict';
  var SOLD_BTN = 'Sold out';
  var SOLD_MSG = "Sold out for now, and nothing was charged. Want an email when it's back?";
  var THANKS_MSG = "Thanks, you're on the list. Nothing was charged.";
  var PERK = 'Join the waitlist — get 10% off at launch.';
  var PENDING_LEAD = 'ss_dt_lead_pending';
  var CHECKOUT_RE = /(^|\/)checkouts?(\/|$|\?|#)/;

  function ssGet(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} }
  function ssDel(k) { try { window.sessionStorage.removeItem(k); } catch (e) {} }
  // v4/v5 left this flag to clear the cart; v6 keeps carts, so drop it without clearing.
  ssDel('ss_dt_clear_pending');

  function publish(name, data) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, data);
      }
    } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('ss:analytics', { detail: { name: name, data: data } })); } catch (e) {}
    try { console.info('[ss] ' + name, JSON.stringify(data)); } catch (e) {}
  }
  // Dawn's pubsub.js / constants.js declare these as top-level script bindings (not window props).
  function hasPubSub() {
    return typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate;
  }
  function slugify(t) {
    return String(t || '').toLowerCase().replace(/['"]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }

  /* ---------- global CSS: hide express/dynamic checkout, show cart icon, sold-out box ---------- */
  (function css() {
    var s = document.createElement('style');
    s.id = 'ss-v6-css';
    s.textContent =
      '.cart__dynamic-checkout-buttons,.additional-checkout-buttons,.dynamic-checkout__content,' +
      'shopify-accelerated-checkout,shopify-accelerated-checkout-cart,.shopify-payment-button,' +
      '[data-shopify="payment-button"],[data-shopify="dynamic-checkout-cart"]{display:none!important}' +
      'header .header__icons .header__icon--cart{display:flex!important}' +
      '.ss-co-wl{margin:1.2rem 0 0;text-align:left;color:var(--ink,#1F1B16)}' +
      '.ss-co-wl>p{margin:0 0 1rem;font-size:1.5rem;line-height:1.45}' +
      '.ss-co-wl form{max-width:420px;margin:0}' +
      '.ss-co-wl input[type="email"]{display:block;box-sizing:border-box;width:100%;max-width:420px;min-height:48px;margin:0;padding:12px 22px;background:#fff;border:1px solid rgba(46,94,78,.35);border-radius:40px;box-shadow:none;color:var(--ink,#1F1B16);font-family:inherit;font-size:16px;line-height:1.3;-webkit-appearance:none;appearance:none}' +
      '.ss-co-wl input[type="email"]::placeholder{color:#6F6A61;opacity:1}' +
      '.ss-co-wl input[type="email"]:focus,.ss-co-wl input[type="email"]:focus-visible{outline:none;border-color:#2E5E4E;box-shadow:0 0 0 1px #2E5E4E,0 0 0 4px rgba(46,94,78,.2)}' +
      '.ss-co-wl .button{display:flex;box-sizing:border-box;width:100%;max-width:420px;min-height:48px;margin:10px 0 0}' +
      '.ss-co-wl .ss-wl-perk{margin:.8rem 0 0;font-size:1.4rem;line-height:1.4;font-weight:600;color:#2E5E4E}';
    (document.head || document.documentElement).appendChild(s);
  })();

  /* ------------------------------------------ PDP ------------------------------------------ */
  (function pdp() {
    var root = document.getElementById('ss-atc');
    var btn = document.getElementById('ss-btn');
    if (!root || !btn) return;
    var label = document.getElementById('ss-btn-label') || btn;
    var form = root.querySelector('form[action*="/cart/add"]');
    var idInput = form ? form.querySelector('[name="id"]') : null;
    var d = root.dataset || {};
    var info = {
      product_id: d.productId || '', product_handle: d.handle || '', product_title: d.title || '',
      variant_id: d.variantId || '', variant_title: d.variantTitle || '', price: parseFloat(d.price) || 0,
      currency: d.currency || 'USD', subscription: d.sub === '1'
    };
    var pills = document.getElementById('ss-pills');
    var radios = pills ? Array.prototype.slice.call(pills.querySelectorAll('input[type="radio"][data-variant-id]')) : [];
    var priceBox = null;
    if (radios.length) {
      var scope = root.closest ? root.closest('.product__info-container, .product__info-wrapper, section') : null;
      priceBox = (scope && scope.querySelector('[id^="price-"]')) || null;
    }
    function syncThemePrice(money, per) {
      if (!priceBox) return;
      var els = priceBox.querySelectorAll('.price__regular .price-item--regular, .price__sale .price-item--sale');
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (el.getAttribute('data-ss-suffix') === null) {
          var m = el.textContent.trim().match(/\s[A-Z]{3}$/);
          el.setAttribute('data-ss-suffix', m ? m[0] : '');
        }
        el.textContent = money + el.getAttribute('data-ss-suffix') + per;
      }
    }
    function selectVariant(input) {
      if (!input) return;
      var od = input.dataset, sub = od.sub === '1';
      info.variant_id = od.variantId || ''; info.price = parseFloat(od.price) || 0;
      info.variant_title = od.title || ''; info.subscription = sub;
      root.setAttribute('data-variant-id', info.variant_id);
      root.setAttribute('data-price', od.price || '');
      root.setAttribute('data-variant-title', info.variant_title);
      root.setAttribute('data-sub', sub ? '1' : '0');
      if (idInput) idInput.value = info.variant_id;
      for (var i = 0; i < radios.length; i++) {
        var r = radios[i]; r.checked = r === input;
        var lab = r.closest ? r.closest('label') : null;
        if (lab) lab.classList.toggle('is-on', r === input);
      }
      var money = od.money || '$' + (Number(od.price) || 0).toFixed(2), per = sub ? '/mo' : '';
      label.textContent = 'Add to cart · ' + money + per;
      syncThemePrice(money, per);
    }
    if (radios.length) {
      pills.addEventListener('change', function (e) {
        var t = e.target;
        if (t && t.matches && t.matches('input[type="radio"][data-variant-id]')) selectVariant(t);
      });
      var initial = null;
      for (var ri = 0; ri < radios.length; ri++) if (radios[ri].checked) { initial = radios[ri]; break; }
      selectVariant(initial || radios[0]);
    }
    // Make sure the submitted id matches the checked pill even if 'change' never fired.
    if (form) form.addEventListener('submit', function () {
      for (var ci = 0; ci < radios.length; ci++) if (radios[ci].checked && radios[ci].dataset.variantId !== String(info.variant_id)) selectVariant(radios[ci]);
    }, true);
    // If Dawn's product-form.js is missing, the form still posts natively to /cart/add -> /cart.
    // One custom AddToCart-type event per SUCCESSFUL add (Dawn publishes cart-update on success only).
    if (hasPubSub()) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (evt) {
        if (!evt || evt.source !== 'product-form' || !evt.cartData) return;
        var li = evt.cartData;
        if (li.product_id && String(li.product_id) !== String(info.product_id)) return;
        var qty = Number(evt.cartData.quantity) || 1;
        var unit = li.final_price != null ? li.final_price / 100 : info.price;
        publish('demand_test_add_to_cart', {
          product_id: String(info.product_id), product_handle: info.product_handle, product_title: info.product_title,
          variant_id: String(li.variant_id || evt.productVariantId || info.variant_id),
          variant_title: li.variant_title || info.variant_title || '', subscription: info.subscription,
          price: unit, quantity: 1, value: unit, currency: info.currency
        });
      });
    }
  })();

  /* ---------------------------------------- CART / CHECKOUT --------------------------------- */
  function isCheckoutEl(el) {
    if (!el || !el.closest) return null;
    var b = el.closest('[data-ss-checkout], button[name="checkout"], input[name="checkout"], #checkout, .cart__checkout-button, ' +
      'a[href*="/checkout"], .additional-checkout-buttons, .cart__dynamic-checkout-buttons, ' +
      'shopify-accelerated-checkout, shopify-accelerated-checkout-cart, .shopify-payment-button');
    if (!b) return null;
    if (b.tagName === 'A' && !CHECKOUT_RE.test((b.getAttribute('href') || '').replace(/^https?:\/\/[^/]+/, ''))) return null;
    return b;
  }
  function hostFor(btn) {
    var note = btn.closest('cart-notification, #cart-notification');
    if (note) {
      var links = (note.querySelector ? note : document).querySelector('.cart-notification__links') || note;
      return { el: links, anchor: links.querySelector('#cart-notification-form') || btn, source: 'cart-notification' };
    }
    var ctas = document.querySelector('#main-cart-footer .cart__ctas') || btn.parentNode;
    return { el: ctas.parentNode || ctas, anchor: ctas, source: /\/cart\/?$/.test(location.pathname) ? 'cart-page' : 'other' };
  }
  var formSeq = 0;
  function soldBox(host, tags) {
    var box = host.el.querySelector('.ss-co-wl');
    if (!box) {
      formSeq++;
      box = document.createElement('div');
      box.className = 'ss-co-wl';
      box.setAttribute('role', 'status');
      box.innerHTML = '<p>' + esc(SOLD_MSG) + '</p>' +
        '<form method="post" action="/contact#contact_form" id="ss_co_form_' + formSeq + '" accept-charset="UTF-8" class="contact-form">' +
        '<input type="hidden" name="form_type" value="customer"><input type="hidden" name="utf8" value="✓">' +
        '<input type="hidden" name="contact[tags]" value="' + esc(tags) + '">' +
        '<input type="email" name="contact[email]" placeholder="Your email" aria-label="Your email" autocomplete="email" required>' +
        '<button type="submit" class="button">Email me when it\'s back</button>' +
        '<p class="ss-wl-perk">' + esc(PERK) + '</p></form>';
      var a = host.anchor;
      if (a && a.parentNode === host.el) host.el.insertBefore(box, a.nextSibling); else host.el.appendChild(box);
    } else {
      var ti = box.querySelector('input[name="contact[tags]"]'); if (ti) ti.value = tags;
    }
    box.hidden = false;
    return box;
  }
  function markSold(btn) {
    var all = document.querySelectorAll('[data-ss-checkout], button[name="checkout"], #checkout, .cart__checkout-button');
    for (var i = 0; i < all.length; i++) {
      var b = all[i];
      if (!b.hasAttribute('data-ss-label')) b.setAttribute('data-ss-label', b.textContent.trim());
      b.textContent = SOLD_BTN; b.setAttribute('aria-disabled', 'true'); b.classList.add('ss-btn--sold');
    }
  }
  function resetSold() {
    var all = document.querySelectorAll('[data-ss-label]');
    for (var i = 0; i < all.length; i++) {
      all[i].textContent = all[i].getAttribute('data-ss-label'); all[i].removeAttribute('aria-disabled');
      all[i].classList.remove('ss-btn--sold'); all[i].removeAttribute('data-ss-label');
    }
    var boxes = document.querySelectorAll('#cart-notification .ss-co-wl');
    for (var j = 0; j < boxes.length; j++) boxes[j].hidden = true;
  }
  function cartTags(cart) {
    var tags = ['waitlist'], seen = { waitlist: 1 };
    (cart && cart.items || []).forEach(function (it) {
      var add = [it.handle];
      if (it.variant_title && !/^default title$/i.test(it.variant_title)) add.push(slugify(it.variant_title));
      add.forEach(function (t) { if (t && !seen[t]) { seen[t] = 1; tags.push(t); } });
    });
    return tags.join(',');
  }
  function cartPayload(cart, source) {
    var items = (cart && cart.items || []).map(function (it) {
      return { variant_id: String(it.variant_id), product_id: String(it.product_id), handle: it.handle,
        title: it.product_title, variant_title: it.variant_title || '', quantity: it.quantity,
        price: it.final_price / 100, line_price: it.final_line_price / 100 };
    });
    return {
      value: cart ? cart.total_price / 100 : 0, currency: (cart && cart.currency) || 'USD',
      item_count: cart ? cart.item_count : 0, items: items,
      content_ids: items.map(function (i) { return i.variant_id; }), source: source
    };
  }
  function getCart() {
    return fetch((window.routes && routes.cart_url ? routes.cart_url : '/cart') + '.js', {
      headers: { Accept: 'application/json' }, credentials: 'same-origin'
    }).then(function (r) { return r.json(); });
  }
  var lastCart = null;
  // Dedupe key for ss_checkout_click: cart token + hash of the line items (key, qty, line price), order-independent.
  function hashStr(str) {
    var h = 5381;
    for (var i = 0; i < str.length; i++) h = ((h << 5) + h + str.charCodeAt(i)) | 0;
    return (h >>> 0).toString(36);
  }
  function clickKey(cart) {
    if (!cart) return 'ss_co_click:nocart';
    var lines = (cart.items || []).map(function (it) {
      return (it.key || it.variant_id) + 'x' + it.quantity + '@' + it.final_line_price;
    }).sort().join('|');
    var tok = String(cart.token || '').split('?')[0];
    return 'ss_co_click:' + tok + ':' + hashStr(lines);
  }
  function publishCheckoutOnce(cart, source) {
    var k = clickKey(cart);
    if (ssGet(k)) { try { console.info('[ss] skip ss_checkout_click (already sent this session for this cart) ' + k); } catch (e) {} return; }
    ssSet(k, String(Date.now()));
    publish('ss_checkout_click', cartPayload(cart, source));
  }
  function onCheckoutTap(btn) {
    var host = hostFor(btn);
    markSold(btn);
    if (host.el.querySelector('.ss-co-wl:not([hidden])')) return; // already showing: repeat taps do not re-count
    var box = soldBox(host, lastCart ? cartTags(lastCart) : 'waitlist');
    getCart().then(function (cart) {
      lastCart = cart;
      var ti = box.querySelector('input[name="contact[tags]"]'); if (ti) ti.value = cartTags(cart);
      publishCheckoutOnce(cart, host.source);
    }).catch(function () { publishCheckoutOnce(null, host.source); });
  }
  // Cart popup "Check out" -> plain navigation to /cart (sold-out + ss_checkout_click only on the /cart Checkout).
  function popupToCart(e) {
    var b = e.target && e.target.closest ? e.target.closest('#cart-notification-form [data-ss-to-cart], #cart-notification-form button[type="submit"]') : null;
    if (!b) return false;
    e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    window.location.assign(window.routes && routes.cart_url ? routes.cart_url : '/cart');
    return true;
  }
  function guard(e) {
    if (e.type === 'click' && popupToCart(e)) return;
    var btn = isCheckoutEl(e.target);
    if (!btn) return;
    e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    if (e.type === 'click') onCheckoutTap(btn);
  }
  document.addEventListener('click', guard, true);
  document.addEventListener('submit', function (e) {
    var f = e.target, sub = e.submitter;
    var toCheckout = (sub && (sub.name === 'checkout' || isCheckoutEl(sub))) ||
      (f && f.getAttribute && CHECKOUT_RE.test((f.getAttribute('action') || '').replace(/^https?:\/\/[^/]+/, '')));
    if (toCheckout) {
      e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      onCheckoutTap(sub || f.querySelector('[data-ss-checkout], [name="checkout"]') || f);
      return;
    }
    // Remember a checkout sold-out email post so the lead event can fire on return.
    if (f && f.closest && f.closest('.ss-co-wl')) {
      ssSet(PENDING_LEAD, JSON.stringify({ src: 'checkout', t: Date.now(), cart: lastCart ? cartPayload(lastCart, 'lead') : null }));
    }
  }, true);
  // Keyboard Enter in a cart quantity field would implicitly submit via the checkout button; the submit guard covers it.
  // New add -> fresh cart popup: restore the Checkout label and hide the old sold-out box there.
  if (hasPubSub()) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (evt) {
      if (evt && evt.source === 'product-form') resetSold();
      getCart().then(function (c) {
        lastCart = c;
        var tis = document.querySelectorAll('.ss-co-wl input[name="contact[tags]"]');
        for (var i = 0; i < tis.length; i++) tis[i].value = cartTags(c);
      }).catch(function () {});
    });
  }

  /* ------------------------------------------ LEAD ----------------------------------------- */
  var pending = ssGet(PENDING_LEAD);
  if (pending && /[?&]customer_posted=true/.test(location.search)) {
    ssDel(PENDING_LEAD);
    var lead = null; try { lead = JSON.parse(pending); } catch (e) {}
    if (lead && lead.src === 'checkout' && !ssGet('ss_dt_lead_checkout')) {
      ssSet('ss_dt_lead_checkout', '1');
      publish('demand_test_lead', lead.cart || { source: 'checkout' });
    }
    if (lead && lead.src === 'checkout' && /\/cart\/?$/.test(location.pathname)) {
      var cbtn = document.querySelector('#main-cart-footer .cart__checkout-button, #checkout');
      if (cbtn) {
        markSold(cbtn);
        var b = soldBox(hostFor(cbtn), 'waitlist');
        var p = b.querySelector('p'); if (p) p.textContent = THANKS_MSG;
        var fm = b.querySelector('form'); if (fm) fm.hidden = true;
      }
    }
  }
})();
